var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"success","small":""},on:{"click":_vm.downloadCSV}},[_vm._v(" Download CSV ")])}
var staticRenderFns = []

export { render, staticRenderFns }